// @react/hooks/useTenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { tenantStore } from '@core/stores';

/**
 * React hook for Tenant operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTenant } from '@react/hooks';
 *
 * const TenantList = observer(() => {
 *   const store = useTenant();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTenant() {
  return tenantStore;
}
